import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Team {
  id: string
  name: string
  /** Campaign this team belongs to — used to cascade Campaign → Team selects. */
  campaignId?: string | null
}

export interface UseTeamsResult {
  teams: Team[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useTeams(fetchOnMount = false): UseTeamsResult {
  const [teams, setTeams] = useState<Team[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ teams: Team[] }>('/admin/user-management/teams/dropdown')
      console.log('Teams response:', res)
      setTeams(res.teams || [])
    } catch (e) {
      console.error('Failed to fetch teams:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch teams')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { teams, loading, error, refetch }
}
